import Skeleton from "./Skeleton"

export default function QuestsLoading({}) {
  return (
    <div className="flex flex-1 flex-col px-4">
      <Skeleton h={130} style="mt-3" />
      <Skeleton w={200} h={36} style="my-3" />
      <Skeleton h={132} />
      <Skeleton w={250} h={36} style="my-3" />
      <Skeleton h={240} />
    </div>
  )
}
